import React, {forwardRef, useState} from 'react';
import { Box, Grid, IconButton, Popover, Snackbar, Tooltip, Typography } from '@mui/material';
import ColorConstants from '../../../defaults/ColorConstants';
import HelpIcon from "@mui/icons-material/Help";
import { useSelector } from 'react-redux';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

// Note: Despite the file name, this should display DefinitionExpression, not FilterExpression,
//        so that the user knows what their currently applied filter is.
//        CurrentFilterExpressionPopup just fits the idea better at a glance

export const CurrentFilterExpressionPopup = forwardRef(() => {
  const [filterPopoverIsOpen, setFilterPopoverIsOpen] = useState(false);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const definitionExpression = useSelector((state) => state.filter.definitionExpression);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const openFilterPopover = (event) => {
    setFilterAnchorEl(event.currentTarget);
    setFilterPopoverIsOpen(true);
  }

  const closeFilterPopover = () => {
    setFilterPopoverIsOpen(false);
    setFilterAnchorEl(null);
  }

  return (
    <div className='blue-msg-bottom' style={{marginRight: "5px"}}>
      <Typography style={{ paddingTop: "1px" }} fontSize={12}>
        Filter: 
      </Typography>
      <IconButton style={{ padding: 0 }} aria-label="Help"
            onClick={(event) => openFilterPopover(event)}>
          <HelpIcon fontSize="small" color="primary" style={{ right: "0px" }} />
      </IconButton>    
      <Popover
        id={'filter-popover'}
        open={filterPopoverIsOpen}
        style={{ minWidth: '300px', maxHeight: '75vh', width: '80vw' }}
        anchorEl={filterAnchorEl}
        onClose={closeFilterPopover}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}>
        <div style={{maxHeight: '375px', overflowY: 'scroll'}}>
          <Box sx={{textAlign: 'center'}}>
            <Typography fontWeight={'bold'} sx={{textDecoration: 'underline'}}>Current Filter Expression</Typography>
            <Typography>{definitionExpression}</Typography>
            <Tooltip title="Copy Filter to Clipboard" enterDelay={400}>
              <IconButton 
                aria-label="Copy to Clipboard"
                onClick={() => {
                  setSnackbarOpen(true);
                  navigator.clipboard.writeText(definitionExpression);
                }}>
                <ContentCopyIcon />
              </IconButton>
            </Tooltip>
            <Snackbar
              open={snackbarOpen}
              autoHideDuration={2000}
              onClose={() => {setSnackbarOpen(false)}}
              message="Copied"
            />
          </Box>
        </div>
      </Popover>
    </div>
  );
});
